import { Text } from '@chakra-ui/react';
import React from 'react';

/**
 * Uppercase section label (MAIN / SOCIAL / ACCOUNT / WORKSPACE / BILLING) shared
 * by the main navigation and the internal panels.
 */
const SidebarSectionLabel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Text
    as="div"
    px="10px"
    mb="6px"
    fontFamily="heading"
    fontSize="10.5px"
    fontWeight={600}
    textTransform="uppercase"
    letterSpacing="0.1em"
    color="navDark.sectionLabel"
  >
    {children}
  </Text>
);

export default SidebarSectionLabel;
